import { CircularProgress, Modal } from "@mui/material";
import PropTypes from "prop-types";
import Button from "./Button";

const SignOutModal = ({ open, onClose, onSignOut, isLoading }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: "flex", overflow: "auto", backdropFilter: "blur(8px)" }}
    >
      <div className="sm:w-89.5 w-72 bg-white m-auto rounded-2xl p-6">
        <p className="text-center text-xl font-semibold mb-4">
          Are you sure you want to sign out?
        </p>
        <p className="text-[#60656D] text-center mb-4">
          You'll need to sign in again to access your account
        </p>
        <div className="flex">
          <Button
            className={`w-full h-10 rounded-xl font-semibold mt-2 transition ease-in-out delay-75 bg-white border ${
              isLoading ? "text-[#757575]" : "text-black hover:scale-105"
            }`}
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            className={`w-full h-10 rounded-xl font-semibold mt-2 text-white transition ease-in-out delay-75 ml-2 ${
              isLoading ? "bg-[#F6F7F7]" : "bg-[#0947AB] hover:scale-105"
            }`}
            onClick={onSignOut}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={"1rem"} /> : "Yes"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

// Define prop types for the component
SignOutModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSignOut: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default SignOutModal;
